// extracted by mini-css-extract-plugin
module.exports = {"body":"ShareFileDialog_body__avHji","actions":"ShareFileDialog_actions__gzExQ"};